import { Box } from '@/components/Box/Box';
import { Button } from '@/components/Button/Button';
import { Notification } from '@/components/Notification/Notification';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';

type SubscriptionSuspendedNotificationType = {
  onRetryPayment: () => void;
  onCustomerPortalNavigate: () => void;
  isLoading: boolean;
};

export const SubscriptionSuspendedNotification = ({
  onRetryPayment,
  onCustomerPortalNavigate,
  isLoading,
}: SubscriptionSuspendedNotificationType) => {
  return (
    <Notification variant='error'>
      <Box width='100%' display='flex' alignItems='center' justifyContent='space-between' columnGap='20px'>
        <Box display='flex' flexDirection='column'>
          <Typography color={COLORS.grey[950]} fontWeight='semibold'>
            Payment failed — your organization account is now in view-only mode.
          </Typography>
          <Typography color={COLORS.grey[700]} variant='bodySmall'>
            We couldn’t process your subscription payment, and your grace period is expired. If your card is correct,
            please ensure it has sufficient balance and <b>retry the payment</b>. If your card is expired or blocked,
            please{' '}
            <NavigationLink to='' onClick={onCustomerPortalNavigate}>
              update your payment method
            </NavigationLink>{' '}
            in the Stripe Customer Portal and then <b>retry the payment</b> there. Your organization currently has{' '}
            <b>view-only</b> access. Please complete your subscription payment to restore full functionality.
          </Typography>
        </Box>
        <Box display='flex' flexShrink={0}>
          <Button width='164px' size='medium' onClick={onRetryPayment} isLoading={isLoading}>
            Retry the payment
          </Button>
        </Box>
      </Box>
    </Notification>
  );
};
